module.exports = __webpack_public_path__ + "media/meowmix.cd1605f5.ogg";